<template>
  <b-modal 
    title="AVISOS EN ALERTA" 
    ref="notice_danger" id="notice_danger" 
    v-model="isShow" 
    no-close-on-backdrop
    scrollable 
    size="xl" 
    :header-bg-variant="dark ? 'dark' : 'light'"
    :header-text-variant="dark ? 'light' : 'dark'" 
    :body-bg-variant="dark ? 'dark' : 'light'"
    :body-text-variant="dark ? 'light' : 'dark'" 
    :footer-bg-variant="dark ? 'dark' : 'light'"
    :footer-text-variant="dark ? 'light' : 'dark'"
    >
    <!-- hide-header-close  -->
    <b-row v-if="!isLoading">
      <b-col md="12" class="mb-2">
        <DxDataGrid 
          :data-source="aNoticeDanger" 
          :show-borders="true" 
          :show-column-lines="true" 
          :show-row-lines="true"
          :row-alternation-enabled="true" 
          :columnAutoWidth="true" 
          :allow-column-resizing="true"
          :word-wrap-enabled="true"
          ref="dataGridNoticeDanger" 
          @selection-changed="onSelectionChanged"
        >
          <DxExport :enabled="true" />

          <!-- <DxSelection :select-all-mode="'allPages'" :show-check-boxes-mode="'always'" mode="multiple" /> -->

          <DxGroupPanel :visible="true" emptyPanelText="Arrastre una columna aquí para agrupar" />
          <DxSearchPanel :visible="true" :width="240" placeholder="Buscar..." />
          <DxPaging :page-size="10" />
          <DxPager :visible="true" infoText="Página {0} de {1} ({2} registros)" :allowed-page-sizes="[5, 10, 15]"
            display-mode="full" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true">
            <DxOperationDescriptions equal="Igual a" notEqual="Diferente de" startsWith="Empieza con"
              endsWith="Termina con" contains="Contiene" between="Entre" notContains="No contiene"
              lessThanOrEqual="Menor o igual" greaterThanOrEqual="Mayor o igual" lessThan="Menor que"
              greaterThan="Mayor que" />
          </DxFilterRow>

          <DxColumn data-field="n_orden" caption="N° AVISO" alignment="left" />

          <DxColumn data-field="ind_peligro" caption="Ind. Peligro" alignment="left" />

          <DxColumn data-field="fecha_ingreso" caption="Fecha de ingreso" data-type="date"
            format="dd/MM/yyyy, HH:mm:ss" />

          <DxColumn data-field="vip" caption="VIP" alignment="left" />

          <DxColumn data-field="tipo_trabajo" caption="Tipo trabajo" alignment="left" />
          <DxColumn data-field="sector" caption="Sector" alignment="left" />
          <DxColumn data-field="subestación" caption="Subestación" alignment="left" />
          <DxColumn data-field="circuito" caption="Circuito" alignment="left" />
          <DxColumn data-field="municipio" caption="Municipio" alignment="left" />
          <DxColumn data-field="tipo_aviso" caption="Tipo de aviso" alignment="left" />
          <DxColumn data-field="descripción" caption="Descripción" alignment="left" width="450" class="wrap-cell" />
          <DxColumn data-field="referencia" caption="referencia" alignment="left" />
          <DxColumn data-field="dirección" caption="Dirección" alignment="left" />

          <DxColumn caption="Acciones" width="150" cell-template="cellTemplate" />
          <!-- <template #cellTemplate="{ data: cellData }">
            <div class="text-center">
              <b-button class="btn btn-xs btn-sm mr-3" variant="primary" @click="onGenerateOT(cellData.data)">
                <i class="la la-play"></i> Generar OT
              </b-button>
            </div>
          </template> -->
          <template #cellTemplate="{ data: cellData }">
            <div class="text-center">

              <!-- SI LATITUD Y LONGITUD ESTÁN VACÍAS -->
              <template v-if="(cellData.data.isButtonSinAlimentacion) && (!cellData.data.latitud || !cellData.data.longitud)">
              <!-- <template v-if="(cellData.data.latitud == null || cellData.data.longitud == null)"> -->
                <b-button
                  class="btn btn-xs btn-success mr-3"
                  @click="onGenerateCoordinates(cellData.data)"
                >
                  <i class="la la-map-marker"></i> Generar coordenada
                </b-button>
              </template>

              <!-- SI LATITUD Y LONGITUD TIENEN VALOR -->
              <template v-else>
                <b-button
                  class="btn btn-xs btn-primary mr-3"
                  @click="onGenerateOT(cellData.data)"
                >
                  <i class="la la-play"></i> Generar OT
                </b-button>
              </template>

            </div>
          </template>

          <DxToolbar>
            <!-- <DxItem location="after" template="clearSelection" /> -->
            <DxItem location="after" template="refreshTemplate" />
            <DxItem name="columnChooserButton" />
            <DxItem name="exportButton" />

            <DxItem name="searchPanel" />
            <DxItem name="groupPanel" />
          </DxToolbar>

          <template #refreshTemplate>
            <DxButton icon="refresh" @click="onGetNoticeDanger()" />
          </template>

          <!-- <template #clearSelection>
            <DxButton icon="clear" :disabled="!aSelectNoticeDangers.length" @click="clearSelection" />
          </template> -->
        </DxDataGrid>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <div class="text-center">
          <img src="assets/img/loader.gif" alt="Loading..." />
        </div>
      </b-col>
    </b-row>
    <!-- <template #modal-footer>
      <div>
        <button class="btn btn-success btn-sm" @click="onGenerateMasiveOt">
          <i class="la la-play"></i> Generar OT Masivo
        </button>
      </div>
    </template> -->
  </b-modal>
</template>

<script>
import axios from "axios";
import { DxButton } from "devextreme-vue/button";
import {
  DxColumn,
  DxDataGrid,
  DxExport,
  DxFilterRow,
  DxGroupPanel,
  DxHeaderFilter,
  DxItem,
  DxOperationDescriptions,
  DxPager,
  DxPaging,
  DxSearchPanel,
  DxToolbar,
  // DxSelection,
} from "devextreme-vue/data-grid";
import moment from 'moment';
import { mapGetters, mapActions } from "vuex";
import toastr from 'toastr'

export default {
  name: "modal-notcie-danger",
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxSearchPanel,
    DxOperationDescriptions,
    DxFilterRow,
    DxHeaderFilter,
    DxPager,
    DxExport,
    DxGroupPanel,
    DxToolbar,
    DxItem,
    DxButton,
    // DxSelection,
  },
  mounted() {

  },
  data() {
    return {
      isShow: false,
      isLoading: false,
      aNoticeDanger: [],
      aSelectNoticeDangers: [],
    };
  },
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
      noticeDanger: "auth/getNoticeDanger",
      noticeSinAlimentacion: "auth/getNoticeSinAlimentacion",
      noticesDangers: "auth/getNoticesDangers",
      noticiesSinAlimentacion: "auth/getNoticiesSinAlimentacion"
    }),
  },
  methods: {
    ...mapActions({
      setNoticesDangers: "auth/setNoticesDangers"
    }),
    onGetNoticeDanger() {
      this.isLoading = true;
      const flagNoticeDanger = JSON.parse(sessionStorage.getItem("dangerNotice") || 'false');
      const flagSinAlimentacionNotice = JSON.parse(sessionStorage.getItem("sinAlimentacionNotice") || 'false');
      const payload = {
        sectores: JSON.parse(sessionStorage.getItem("sectores")),
        cors: sessionStorage.getItem("cor").split(",").map(el => el.replace(/'/g, '')),
        hasAvisoPeligro: true,
        hasAvisoSinAlimentacion: true
      }
      let dataFilter = [];
      axios.post("getavisospeligro", payload).then(({ status, data }) => {
          if (status === 200 && data.avisos.length > 0) {
            if (flagSinAlimentacionNotice) {
            dataFilter.push(...data.avisos.filter(aviso => !aviso.latitud && !aviso.longitud));
          }
          if (flagNoticeDanger) {
            data.avisos
              .filter(aviso => Number(aviso.ind_peligro) === 1)
              .forEach(aviso => {
                const existe = dataFilter.some(
                  item => item.id_aviso === aviso.id_aviso
                );

                if (!existe) {
                  dataFilter.push(aviso);
                }
              });
          }
          this.$emit("lengthNoticesDangers", data.totalAvisosPeligro);
          this.$emit("lengthNoticesSinAlimentacion", data.totalAvisosSinAlimentacion);
          this.adapterNoticesDangers(dataFilter);
          if(flagNoticeDanger || flagSinAlimentacionNotice){
            this.isShow = true;
            sessionStorage.setItem("isShowModalNoticesDangers", true);
            if (this.$route.path !== "/works") {
              this.$router.replace('/works');
            }
          }
        } else {
          this.$emit("lengthNoticesDangers", 0);
          this.$emit("lengthNoticesSinAlimentacion", 0);
          this.isShow = false;
          sessionStorage.setItem("isShowModalNoticesDangers", false);
        }
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
        this.isLoading = false;
      });
    },
    adapterNoticesDangers(data) {
      this.aNoticeDanger = data.map((el) => ({
        // ...el,
        id: el.id_aviso,
        id_aviso: el.id_aviso,
        n_orden: el.num_aviso,
        fecha_ingreso: moment(el.fecha_alta).format("LLL"),
        vip: el.ind_cli_vip == 0 ? "NO" : "SI",
        tipo_trabajo: el.tipo_trabajo_id == 1 ? "AVISO" : el.tipo_trabajo_id == 2 ? "INCIDENCIA" : "DESCARGO",
        sector: el.sector,
        subestación: el.subestacion,
        circuito: el.circuito_sm,
        municipio: el.municipio,
        // tipo_aviso: el.tipo_aviso,
        descripción: `${el.observacion} ${el.tipo_trabajo_id == 3 || el.tipo_trabajo_id == 2 ? el.obs_estado_incidencia : ""}`,
        referencia: `${el.dir_ref} ${el.dir_suscriptor} ${el.tipo_trabajo_id == 3 || el.tipo_trabajo_id == 2 ? el.desc_incidencia : ""}`,
        dirección: el.dir_suscriptor,
        ind_peligro: el.ind_peligro === 1 ? "SI" : "NO",

        // FOR ASSIGN OT MASIVO
        tipo_aviso: el.tipo_aviso,
        dir_suscriptor: el.dir_suscriptor,
        barrio: el.barrio,
        dir_ref: el.dir_ref,
        observacion: el.observacion,

        // faltan estos elementos
        imgIcon: el.imgIcon,
        tipo_trabajo_nombre: el.tipo_trabajo_nombre,

        // LONGITUD Y LATITUD
        longitud: el.longitud,
        latitud: el.latitud,
        slug: el.slug,
        selected: el.selected ? true : false,
        isUpdateCoordinates: "Actualizar coordenadas",
        isButtonSinAlimentacion: JSON.parse(sessionStorage.getItem("sinAlimentacionNotice") || 'false')
      }));
    },
    onGenerateOT(noticeDanger) {
      const newNoticesDangers = {
        selectNoticeDanger: { id: noticeDanger.id },
        selectedsNoticesDangers: [],
        isUpdateTable: false,
        isShowModalOT: true,
      };
      sessionStorage.setItem("noticesDangers", JSON.stringify(newNoticesDangers));
      this.setNoticesDangers(newNoticesDangers);
    },
    onGenerateCoordinates(data) {
      this.$emit("generate-coordinates", data);
      this.isShow = false;
      sessionStorage.setItem("isShowModalNoticesDangers", false);
    },
    onGenerateMasiveOt() {
      if (this.aSelectNoticeDangers.length === 0) {
        toastr.info("Seleccione al menos un aviso de peligro");
        return;
      }
      const newNoticesDangers = {
        selectNoticeDanger: null,
        selectedsNoticesDangers: this.aSelectNoticeDangers.map((el) => ({
          id: el.id,
          id_aviso: el.id_aviso,
          num_aviso: el.n_orden,
          tipo_aviso: el.tipo_aviso,
          imgIcon: el.imgIcon,
          tipo_trabajo_nombre: el.tipo_trabajo_nombre,
          dir_suscriptor: el.dir_suscriptor,
          barrio: el.barrio,
          dir_ref: el.dir_ref,
          observacion: el.observacion,
        })),
        isUpdateTable: false,
        isShowModalOT: true,
      }
      sessionStorage.setItem("noticesDangers", JSON.stringify(newNoticesDangers));
      this.setNoticesDangers(newNoticesDangers);
      // this.isShow = false;
    },
    onSelectionChanged(event) {
      this.aSelectNoticeDangers = event.selectedRowsData;
    },
    clearSelection() {
      const dataGrid = this.$refs.dataGridNoticeDanger.$_instance;
      this.aSelectNoticeDangers = [];
      dataGrid.deselectAll();
    }
  },
  watch: {
    noticeDanger(newNoticeDanger) {
      if (newNoticeDanger) {
        this.onGetNoticeDanger();
      }
    },
    noticeSinAlimentacion(newValue) {
      if (newValue) {
        this.onGetNoticeDanger();
      }
    },
    noticesDangers(newValue) {
      if (newValue.isUpdateTable) {

        if (newValue.selectNoticeDanger !== null) {
          this.aNoticeDanger = this.aNoticeDanger.filter((noticeDanger) => noticeDanger.id !== newValue.selectNoticeDanger.id);
          this.setNoticesDangers({ ...newValue, isUpdateTable: false });
          if (this.aNoticeDanger.length === 0) {
            this.isShow = false;
            sessionStorage.setItem("isShowModalNoticesDangers", false);
          }
        }

        if (newValue.selectedsNoticesDangers.length > 0) {
          const ids_notice = newValue.selectedsNoticesDangers.map((el) => el.id);
          this.aNoticeDanger = this.aNoticeDanger.filter((noticeDanger) => !ids_notice.includes(noticeDanger.id));
          this.setNoticesDangers({ ...newValue, isUpdateTable: false });
          if (this.aNoticeDanger.length === 0) {
            this.isShow = false;
            sessionStorage.setItem("isShowModalNoticesDangers", false);
          }
        }
      }
    },
  }
};
</script>
<style>
/* Permitir que el texto haga multi-line wrap */
.wrap-cell {
  white-space: normal !important;
  word-wrap: break-word;
}
</style>